/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Release } from '../../../../ts/release';

export const RELEASE_STATUS = {
  PROCESSING: 'Processing',
  AVAILABLE: 'Available',
  FAILED: 'Failed'
};

export const isProcessing = (release: Release) =>
  release?.status === RELEASE_STATUS.PROCESSING;

export const isFailed = (release: Release) =>
  release?.status === RELEASE_STATUS.FAILED;
